<template>
  <article :id="'PR' + boardInfo.bltndSno" class="mmp_promotion">

    <div
      id="content"
      class="content"
    >

      <section class="promotion_wrap">
        <div class="inner">

          <!-- LNB -->
          <!-- NOTE: 사용하지 않음 -->
          <aside class="lnb">
            <p class="tit">EVENT</p>
            <ul class="lnb_list">
              <li>
                <!-- 현재 활성화된 링크에 'active' 클래스 추가 -->
                <a class="link_lnb active">EVENT</a>
              </li>
              <li>
                <a class="link_lnb">추천 클래스</a>
              </li>
            </ul>
          </aside>
          <!-- // LNB -->

          <!-- PROMOTION CONTENT WRAPPER -->
          <div class="wrap_promotion_content">

            <!-- 페이지 타이틀 -->
            <h2>EVENT</h2>
            <!-- // 페이지 타이틀 -->

            <div class="wrap_promotion_title">
              <!-- 프로모션 타이틀 -->
              <h3>{{ boardInfo.title }}</h3>
              <!-- // 프로모션 타이틀 -->

              <!-- view count -->
              <div class="wrap_view_cnt">
                <span class="cnt">{{ boardInfo.inqrNum }}</span>
              </div>
              <!-- // view count -->
            </div>

            <!-- 프로모션 콘텐츠 -->
            <div ref="promoContWrapper" :class="['promotion_content', deviceType]">
              <!-- 실제 사용할 코드-->
              <!--v-runtime-template :template="boardInfo.bltndBdtCntnt"/-->
              <!-- <div class="promotion_content" v-html="boardInfo.bltndBdtCntnt"/> -->
              <!-- // 실제 사용할 코드 -->

              <!-- 샘플 코드 -->
              <CompPromotionHtml :key="promoKey" :template="boardInfo.bltndBdtCntnt" />
              <!-- // 샘플 코드 -->

            </div>
            <!-- // 프로모션 콘텐츠 -->

            <!-- 공유하기 버튼 -->
            <!-- <div class="pos_relative" style="padding-top:30px;">
              <div class="pc_only" style="text-align:center;background-color:#fff;">
                <button ref="shareEventBtn" class="btn_share" data-share-btn>공유하기</button>
              </div>
              <div class="mo_only" style="text-align:center;background-color:#fff;">
                <button ref="shareEventBtn" class="btn_share" data-share-btn>공유하기</button>
              </div>
            </div> -->
            <!-- // 공유하기 버튼 -->

            <!-- 프로모션 푸터 -->
            <div class="promotion_footer">

              <div class="wrap_button">

                <!--
                  이벤트 참여 동의 버튼
                  - mgmt 관리값 사용하지 않고 html소스에 추가하기로 함
                -->
                <!-- <button v-if="isVisible" ref="joinEventBtn" class="btn_agree" @click="goAgree">[필수] 이벤트 참여 동의하기</button> -->
                <!-- <button ref="joinEventBtn" class="btn_agree" @click="goAgree">[필수] 이벤트 참여 동의하기</button> -->
                <!-- // 이벤트 참여 동의 버튼 -->

                <!-- 목록 보기 버튼 -->
                <button
                  class="btn_view_list"
                  @click="goBoardList"
                >목록</button>
                <!-- // 목록 보기 버튼 -->

              </div>

            </div>
            <!-- // 프로모션 푸터 -->

          </div>
          <!-- // PROMOTION CONTENT WRAPPER -->

        </div>
      </section>

    </div>

    <!-- floating navigation -->
    <!-- <CompFloatNav
      v-if="isDesktop"
      :show-ai-tutor="true"
      :show-goto-top="true"
    /> -->
    <!-- // floating navigation -->

    <!-- bottom navigation(MO) -->
    <!-- <BottomNav v-if="!isDesktop && hasMmpBottomNav" /> -->
    <!-- // bottom navigation(MO) -->

  </article>
</template>
<script>
import CompPromotionHtml from '~pages/nrw/board/CompPromotionHtml.vue'
import commonMixin from '@/mixin/commonMixin'
import EventJoinAgreementModal from '~pages/nrw/modal/EventJoinAgreementModal.vue' // 이벤트 참여 동의하기 모달 팝업
import ShareModal from '~pages/nrw/modal/ShareModal.vue' // 공유하기 모달 팝업

export default {
  name: 'BoardDetail',
  components: {
    CompPromotionHtml,
    EventJoinAgreementModal,
    ShareModal
  },
  mixins: [commonMixin],
  data () {
    return {
      hasMmpHeader: true, // 헤더 존재 여부
      hasMmpFooter: true, // 푸터 존재 여부
      hasMmpBottomNav: true, // bottom navigation 존재 여부
      isLoaded: false, // 메인 콘텐츠 로딩 완료 여부
      boardInfo: {}, // 게시물 상세
      attachFileList: [], // 첨부파일목록
      dsMstr: {}, // 게시판 정보
      rePlyList: [], // 답변목록
      isVisible: false,
      promoKey: 0
      /* // 프로모션 데이터
      promotion: {
        id: '17455378', // 프로모션 고유값
        title: '', // 프로모션 제목
        viewCnt: 0, // 뷰 카운트
        htmlContent: '' // HTML 소스
      } */
    }
  },
  computed: {
    // 현재 디바이스 명 (pc, mobile, tablet)
    deviceType () {
      return window.vue.getStore('homeInfo').state.deviceType
    },
    isLogin () {
      return window.vue.getStore('root').state.session.authenticated
    },
    bltndMstrSno () {
      return this.$route.query.bltndMstrSno
    },
    bltndSno () {
      return this.$route.query.bltndSno
    },
    statusClass () {
      return this.$route.query.statusClass
    }
  },
  watch: {

  },
  beforeCreate () {

  },
  created () {
    this.selectBoardDetail()
  },
  beforeMount () {

  },
  mounted () {

  },
  beforeUpdate () {

  },
  updated () {

  },
  beforeDestroy () {

  },
  methods: {
    // 게시판 상세 조회
    selectBoardDetail () {
      let params = {
        bltndMstrSno: this.bltndMstrSno,
        bltndSno: this.bltndSno
      }
      console.log(params)
      this.fetchData('selectBoardDetail', params, (data) => {
        console.log('Detail', data)
        this.boardInfo = data.boardInfo
        this.attachFileList = data.attachFileList
        this.dsMstr = data.dsMstr
        this.rePlyList = data.rePlyList
        // 이벤트 동의 표시
        if (this.boardInfo.agrmtTgtYn === 'Y') {
          this.isVisible = true
        } else {
          this.isVisible = false
        }
        // CompPromotionHtml 변경 setting
        this.$nextTick(function () {
          this.promoKey++
        })
        // console.log('>>>>>>>>>>, agrmtTgtYn', this.boardInfo.agrmtTgtYn)
      })
    },
    // 공유하기
    share () {
      // console.log('공유하기')
      this.$popup.openModal(this.$el, ShareModal, {
        fullModal: false,
        title: '공유하기',
        eventNm: this.boardInfo.bltndTitlNm,
        bltndMstrSno: String(this.boardInfo.bltndMstrSno),
        bltndSno: String(this.boardInfo.bltndSno),
        header: true,
        footer: false
      })
    },
    // 필수 이벤트 참여 동의하기
    goAgree () {
      console.log('>>>>>>>>>> isLogin', this.isLogin)
      if (this.boardInfo.agrmtTgtYn !== 'Y') {
        this.$popup.alert(this.$el, {title: '알림', contents: '이벤트 기간이 아닙니다.'})
        return
      }
      if (this.isLogin) {
        this.$popup.openModal(this.$el, EventJoinAgreementModal, {
          fullModal: false,
          title: '이벤트 개인정보 수집 및&nbsp;<br>이용 동의서',
          header: true,
          footer: true,
          bltndMstrSno: this.bltndMstrSno,
          bltndSno: this.bltndSno,
          statusClass: this.statusClass
        })
      } else {
        this.moveToLogin()
      }
      // console.log('필수 이벤트 참여 동의하기')
      // NOTE: 필수 이벤트 참여 동의하기 처리
    },
    // 게시판 목록 바로가기
    goBoardList () {
      // console.log('목록 보기')
      // NOTE: 목록 바로가기 처리
      // this.$router.back()
      this.$goPage({name: 'BoardMstr', query: {bltndMstrSno: String(this.bltndMstrSno)}})
    },
    moveToLogin () {
      this.isOpen = false
      this.$goPage({name: 'Login'})
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/pages/nrw/board/BoardDetail.vue